module.exports = __webpack_public_path__ + "img/call_missed.3e7e15b4.svg";